import { db } from '../firebase';
import { MANAGER_ROLE, WORKER_ROLE, CO_MANAGER_ROLE } from '../../utils/constants';
import { Base64 } from 'js-base64';
var _ = require('lodash');

export const getUsersProjects = email => {
    return Promise.all([
        db.ref(`users/${Base64.encode(email)}/projects/${MANAGER_ROLE}`)
            .once('value')
            .then(snapshot => snapshot.val() || {}),
        db.ref(`users/${Base64.encode(email)}/projects/${WORKER_ROLE}`)
            .once('value')
            .then(snapshot => snapshot.val() || {}),
        db.ref(`users/${Base64.encode(email)}/projects/${CO_MANAGER_ROLE}`)
            .once('value')
            .then(snapshot => snapshot.val() || {})
    ])
        .then(projects => {
            const allProjects = Object.keys(projects[0])
                .concat(Object.keys(projects[1]))
                .concat(Object.keys(projects[2]));
            return allProjects;
        });
};

export const getAllMembers = projects => {
    return Promise.all(
        projects.map(projectId => {
            return db.ref(`projects/${projectId}/members`)
                .once('value')
                .then(snapshot => {
                    const members = snapshot.val() || {};
                    return Object.keys(members).reduce((acc, memberId) => Object.assign(acc, { [`${memberId}:${members[memberId]}`]: true }), {});
                });
        }))
        .then(allMembers => allMembers.reduce((acc, item) => acc.concat(item), [])
            .reduce((acc, obj) => Object.assign(acc, obj), {}));

};

export const getAllInvolvedUsers = email => {
    return getUsersProjects(email)
        .then(projects => Promise.all(projects.map(projectId => db.ref(`projects/${projectId}/members`).orderByKey()
            .equalTo(Base64.encode(email)).once('value').then(snapshot => Object.assign({}, { [projectId]: Object.values(snapshot.val()) }) || {}))))
};


const getAssignedTask = project => {
    return db.ref('subTasks')
        .orderByChild('project')
        .equalTo(project)
        .once('value')
        .then(snapshot => {
            const subTasks = snapshot.val() || {};
            return Object.keys(subTasks)
                .filter(subTaskId => subTasks[subTaskId].assignedTo && !subTasks[subTaskId].finished)
                .reduce((acc, subTaskId) => Object.assign(acc, { [subTaskId]: subTasks[subTaskId] }), {});
        });
};

export const getAssignedTasks = projects => {
    return Promise.all(projects.map(getAssignedTask))
        .then(assignedSubTasks => {
            return assignedSubTasks.reduce((acc, item) => acc.concat(item), [])
                .reduce((acc, obj) => Object.assign(acc, obj), {})
        })
};

export const getNumberOfMyOpenTasksOnProject = (projectId, email) => {
    return db.ref('subTasks')
        .orderByChild('project')
        .equalTo(projectId)
        .once('value')
        .then(snapshot => {
            const promiseArray = [];
            snapshot.forEach((child) => {
                promiseArray.push(db.ref().child(`tasks/${child.val().task}`).once('value')
                    .then((task) => ({
                        subTask: child.val(),
                        task: task.val(),
                    })));
            });
            return Promise.all(promiseArray)
                .then((arr) => {
                    return arr
                        .filter((o) => o && o.subTask.assignedTo === email && !o.subTask.finished && o.task.active).length
                })
        });
}

export const getFieldValue = (collection, id, field) => {
    return db.ref(`${collection}/${id}`)
        .once('value')
        .then(snapshot => {
            return snapshot.val()[field]
        });
}

export const getWorkers = subTasks => {
    return Object.keys(subTasks).reduce((acc, subTaskId) => {
        const userId = subTasks[subTaskId].assignedTo;
        const project = subTasks[subTaskId].project;
        getNumberOfMyOpenTasksOnProject(project, userId).then((number => {
            getFieldValue('projects', project, 'title').then((name => {
                if (!acc[userId]) {
                    return acc[userId] = { [project]: { [name]: number } };
                } else {
                    return acc[userId] = Object.assign(acc[userId], { [project]: { [name]: number } })
                }
            }))
        }))
        return acc;
    }, {})
};

export const getFieldValueDropdown = (collection, id, field) => {
    return db.ref(`${collection}/${id}`)
        .once('value')
        .then(snapshot => {
            return { label: snapshot.val()[field], value: id }
        });
}


export const getProjectTitles = projects => Promise.all(projects.map(projectId => getFieldValueDropdown('projects', projectId, 'title')));


export const prepareFilters = (tasks) => {
    const tasksArray = Object.keys(tasks).map(projectId => tasks[projectId]);
    const filters = tasksArray.reduce((result, subTask) => {
        result.projects.push(subTask.project);
        return result;
    }, {
            projects: [],
        });
    return Promise.all([
        getProjectTitles(_.uniq(filters.projects)),
    ]);
};


export const getTasks = (email) => {
    const encodedEmail = window.btoa(email);
    return db.ref().child('subTasks').orderByChild('assignedTo').equalTo(encodedEmail)
        .once('value')
        .then((snapshot) => {
            const promiseArray = [];
            snapshot.forEach((child) => {
                promiseArray.push(db.ref().child(`tasks/${child.val().task}`).once('value')
                    .then((task) => {
                        return db.ref().child(`cycles/${task.val().cycle}`).once('value')
                            .then(name => {
                                return db.ref().child(`projects/${task.val().project}`).once('value')
                                    .then(pro => pro.val() && ({
                                        subTaskId: child.key,
                                        subTask: child.val(),
                                        task: task.val(),
                                        cycles: name.val(),
                                        project: pro.val()
                                    }));
                            });
                    }));
            });
            return Promise.all(promiseArray)
                .then((arr) => {
                    return _.chain(arr)
                        .filter((o) => o && o.subTask && !o.subTask.finished)
                        .groupBy('subTask.project')
                        .value()
                })
        });
};


// WEBPACK FOOTER //
// ./src/firebase/db/team.js